export default __webpack_public_path__ + "static/media/mobile_vantagens.edeb7409.png";